import flatten from 'lodash/flatten';
import filter from 'lodash/filter';

import { ORGANIZER_POPULAR_CATEGORIES } from 'consumer-utils/constants/categories';

export const getSortedOrganizersByPopularCategories = (organizers) =>
    flatten(
        ORGANIZER_POPULAR_CATEGORIES.map((category) =>
            filter(organizers, ({ categoryId }) => category === categoryId),
        ),
    );

export const setFollowedByYouInFTF = (FTFContent, userFollowedOrganizerIds) =>
    FTFContent.map((content) => {
        const processedArticles = content.organizer_articles.map((article) => {
            if (userFollowedOrganizerIds.includes(article.id)) {
                // eslint-disable-next-line camelcase, no-param-reassign
                return { ...article, followed_by_you: true };
            }
            return article;
        });

        return {
            ...content,
            // eslint-disable-next-line camelcase, no-param-reassign
            organizer_articles: processedArticles,
        };
    });
